import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MemberShipOptions } from 'constants/index';
import SubMenu from 'components/common/SubMenu';
import MembershipInfo from './components/MembershipInfo';
import PrivateSpace from './components/PrivateSpace';

var SpaceOptionService = function SpaceOptionService() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubMenu, {
      options: MemberShipOptions,
      selected: "\uACF5\uAC04\uC635\uC158"
    }), /*#__PURE__*/_jsx("div", {
      className: "cnts-wrap",
      children: /*#__PURE__*/_jsxs("div", {
        className: "membership-w soption-w",
        children: [/*#__PURE__*/_jsx(MembershipInfo, {}), /*#__PURE__*/_jsx(PrivateSpace, {})]
      })
    })]
  });
};

export default SpaceOptionService;